<template>
  <div id="settings" class="wrrapper mb-1">
    <page-heading title="Bussiness Settings" border> </page-heading>
    <div class="settings-template">
      <div class="content">
        <div class="logo_div">
          <div>
            <div class="setting_logo">
              <img :src="this.bussinessData.logoUrl" alt="" class="logoImage" />
            </div>
            <div v-if="progressStatus">
              <ProgressBar
                v-if="uploadProgress > 1"
                :completed="uploadProgress"
              />
              <p class="text-center" v-if="uploadProgress == 100">
                Logo Uploaded ✅
              </p>
            </div>
            <Upload
              label="Change Logo"
              @update-picture="handleFileUpload"
              for="upload-photo"
              class="flex justify-center upload_button"
            />
          </div>
        </div>
        <Input
          class="mb-base"
          label="Name"
          type="text"
          v-model="bussinessData.bussinessName"
        />
        <!-- <Input
          class="mb-base"
          label="Email"
          type="text"
          v-model="bussinessData.email"
        />
        <Input
          class="mb-base"
          label="Phone"
          type="text"
          v-model="bussinessData.phoneNumber"
        /> -->
        <h2 class="bussiness-header">Header</h2>
        <TemplateEditor ref="header" height="200" />
        <h2 class="bussiness-header">Footer</h2>
        <TemplateEditor ref="footer" height="200" />
        <h2 class="bussiness-header">Note</h2>
        <TemplateEditor ref="note" height="200" />
      </div>
      <div class="flex justify-end align-center">
        <Button
          className="button--primary save-template"
          :title="settings && settings.length > 0 ? 'Update' : 'Save'"
          :loader="loading"
          :onClick="saveData"
        ></Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import TemplateEditor from "@/components/TemplateEditor";
import Input from "@/components/Input";
import { mapActions, mapGetters } from "vuex";
import Upload from "../../../components/Upload.vue";
import { encryptData, decryptData } from "@/utils/helpers";
import ProgressBar from "../../../components/ProgressBar.vue";

export default {
  components: {
    TemplateEditor,
    Button,
    Input,
    Upload,
    ProgressBar
  },
  data() {
    return {
      id: "",
      progressStatus: false,
      bussinessData: {
        logoUrl: "",
        bussinessName: null,
        branchAddress: null,
        email: null,
        phoneNumber: null,
        attachmentId: null
      }
    };
  },
  methods: {
    ...mapActions("bussiness", [
      "addBussinessSettings",
      "updateSettings",
      "settingsList"
    ]),
    ...mapActions("auth", ["uploadAttachment"]),
    saveData() {
      const template = {
        header: this.$refs.header.editor.getContents(),
        footer: this.$refs.footer.editor.getContents(),
        note: this.$refs.note.editor.getContents(),
        name: this.bussinessData.bussinessName,
        logoPath: this.bussinessData.logoUrl
          ? this.bussinessData.logoUrl
          : null,
        attachmentId: this.attachmentId,
        sms_module: this.bussinessData.smsModule
      };
      if (this.settings.length > 0) {
        this.updateSettings({ id: this.id, payload: template }).then(() => {
          this.$toasted
            .success("Bussiness settings updated successfully")
            .goAway("3000");
          location.reload();
        });
      } else {
        this.addBussinessSettings(template).then(() => {
          this.$toasted
            .success("Bussiness settings saved successfully")
            .goAway("3000");
        });
      }
      const data = decryptData(
        localStorage.getItem("userInfo"),
        process.env.VUE_APP_SECRET_KEY
      );

      const userData = { ...data, bussinessLogoUrl: this.attachmentUrl };
      const userInfo = encryptData(userData, process.env.VUE_APP_SECRET_KEY);
      localStorage.setItem("userInfo", userInfo);
    },
    handleFileUpload(file) {
      this.uploadAttachment({ file: file }).then(() => {
        this.bussinessData.logoUrl = this.attachmentUrl;
        if (this.uploadProgress > 1) {
          this.progressStatus = true;
        }
        if (this.uploadProgress == 100) {
          setTimeout(() => {
            this.progressStatus = false;
          }, 4000);
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      settings: "bussiness/settings",
      loading: "loading",
      attachmentUrl: "auth/attachmentUrl",
      attachmentId: "auth/attachmentId",
      uploadProgress: "auth/uploadProgress",
      userInfo: "auth/userInfo"
    })
  },
  watch: {
    settings(val) {
      const ref = this.$refs || {};
      const item = val.find(item => item);
      if (item) {
        ref.header.editor.setContents(item.header, "api");
        ref.footer.editor.setContents(item.footer, "api");
        ref.note.editor.setContents(item.note, "api");
        this.id = item.id ? item.id : "";
      }
    }
  },
  mounted() {
    this.settingsList().then(() => {
      this.bussinessData.logoUrl = this.settings[0]?.logoPath;
      this.bussinessData.phoneNumber = this.settings[0]?.phone_number;
      this.bussinessData.bussinessName = this.settings[0]?.tenant?.name;
      this.bussinessData.email = this.settings[0]?.email;
      this.bussinessData.smsModule = this.settings[0].tenant?.sms_module;
    });
  }
};
</script>

<style>
#settings .settings-template {
  padding: 22px 65px 22px 65px;
}
#settings .save-template {
  padding: 13px 50px;
  margin-top: 65px;
}
.bussiness-header {
  font-weight: 600;
  font-size: var(--fs-h2);
  line-height: 1.4;
  color: var(--ink-900);
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}
.logo_div {
  display: flex;
  justify-content: center;
}
.setting_logo {
  width: 12rem;
  height: 12rem;
  border-radius: 50%;
  border: 2px solid var(--line-strong);
  margin: 1rem 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.upload_button {
  margin: 1rem 0;
  border: 1px solid var(--line);
  padding-top: 5px;
  border-radius: 50px;
  box-shadow: var(--shadow-sm);
}
.logoImage {
  max-width: 100%;
  /* height: 3vw; */
}
</style>
